/** Common country dial codes (aligned with ATW monolith). */
export type CountryCode = {
  id: string;
  code: string;
  country: string;
  flag: string;
};

export const COUNTRY_CODES: CountryCode[] = [
  { id: "us", code: "+1", country: "United States", flag: "🇺🇸" },
  { id: "ca", code: "+1", country: "Canada", flag: "🇨🇦" },
  { id: "gb", code: "+44", country: "United Kingdom", flag: "🇬🇧" },
  { id: "au", code: "+61", country: "Australia", flag: "🇦🇺" },
  { id: "nz", code: "+64", country: "New Zealand", flag: "🇳🇿" },
  { id: "za", code: "+27", country: "South Africa", flag: "🇿🇦" },
  { id: "fr", code: "+33", country: "France", flag: "🇫🇷" },
  { id: "de", code: "+49", country: "Germany", flag: "🇩🇪" },
  { id: "it", code: "+39", country: "Italy", flag: "🇮🇹" },
  { id: "es", code: "+34", country: "Spain", flag: "🇪🇸" },
  { id: "nl", code: "+31", country: "Netherlands", flag: "🇳🇱" },
  { id: "be", code: "+32", country: "Belgium", flag: "🇧🇪" },
  { id: "ch", code: "+41", country: "Switzerland", flag: "🇨🇭" },
  { id: "at", code: "+43", country: "Austria", flag: "🇦🇹" },
  { id: "se", code: "+46", country: "Sweden", flag: "🇸🇪" },
  { id: "no", code: "+47", country: "Norway", flag: "🇳🇴" },
  { id: "dk", code: "+45", country: "Denmark", flag: "🇩🇰" },
  { id: "fi", code: "+358", country: "Finland", flag: "🇫🇮" },
  { id: "ie", code: "+353", country: "Ireland", flag: "🇮🇪" },
  { id: "pt", code: "+351", country: "Portugal", flag: "🇵🇹" },
  { id: "gr", code: "+30", country: "Greece", flag: "🇬🇷" },
  { id: "pl", code: "+48", country: "Poland", flag: "🇵🇱" },
  { id: "cz", code: "+420", country: "Czech Republic", flag: "🇨🇿" },
  { id: "hu", code: "+36", country: "Hungary", flag: "🇭🇺" },
  { id: "ro", code: "+40", country: "Romania", flag: "🇷🇴" },
  { id: "ru", code: "+7", country: "Russia", flag: "🇷🇺" },
  { id: "jp", code: "+81", country: "Japan", flag: "🇯🇵" },
  { id: "kr", code: "+82", country: "South Korea", flag: "🇰🇷" },
  { id: "cn", code: "+86", country: "China", flag: "🇨🇳" },
  { id: "hk", code: "+852", country: "Hong Kong", flag: "🇭🇰" },
  { id: "sg", code: "+65", country: "Singapore", flag: "🇸🇬" },
  { id: "my", code: "+60", country: "Malaysia", flag: "🇲🇾" },
  { id: "th", code: "+66", country: "Thailand", flag: "🇹🇭" },
  { id: "id", code: "+62", country: "Indonesia", flag: "🇮🇩" },
  { id: "ph", code: "+63", country: "Philippines", flag: "🇵🇭" },
  { id: "vn", code: "+84", country: "Vietnam", flag: "🇻🇳" },
  { id: "in", code: "+91", country: "India", flag: "🇮🇳" },
  { id: "pk", code: "+92", country: "Pakistan", flag: "🇵🇰" },
  { id: "bd", code: "+880", country: "Bangladesh", flag: "🇧🇩" },
  { id: "lk", code: "+94", country: "Sri Lanka", flag: "🇱🇰" },
  { id: "ae", code: "+971", country: "United Arab Emirates", flag: "🇦🇪" },
  { id: "sa", code: "+966", country: "Saudi Arabia", flag: "🇸🇦" },
  { id: "il", code: "+972", country: "Israel", flag: "🇮🇱" },
  { id: "eg", code: "+20", country: "Egypt", flag: "🇪🇬" },
  { id: "ng", code: "+234", country: "Nigeria", flag: "🇳🇬" },
  { id: "ke", code: "+254", country: "Kenya", flag: "🇰🇪" },
  { id: "br", code: "+55", country: "Brazil", flag: "🇧🇷" },
  { id: "mx", code: "+52", country: "Mexico", flag: "🇲🇽" },
  { id: "ar", code: "+54", country: "Argentina", flag: "🇦🇷" },
  { id: "cl", code: "+56", country: "Chile", flag: "🇨🇱" },
  { id: "co", code: "+57", country: "Colombia", flag: "🇨🇴" },
  { id: "pe", code: "+51", country: "Peru", flag: "🇵🇪" },
  { id: "tr", code: "+90", country: "Turkey", flag: "🇹🇷" },
];

export function getCountryCodeById(id: string): CountryCode | undefined {
  return COUNTRY_CODES.find((country) => country.id === id);
}

export function formatCountryCodeLabel(country: CountryCode): string {
  return `${country.country} (${country.code})`;
}

export function filterCountryCodes(query: string): CountryCode[] {
  const q = query.trim().toLowerCase();
  if (!q) return COUNTRY_CODES;
  const digits = q.replace(/\D/g, "");
  return COUNTRY_CODES.filter((c) => {
    if (c.country.toLowerCase().includes(q)) return true;
    if (c.id.includes(q)) return true;
    if (c.code.toLowerCase().includes(q)) return true;
    if (digits && c.code.replace(/\D/g, "").includes(digits)) return true;
    return false;
  });
}

export function coerceCountryCodeId(id: string | undefined | null, fallback = "us"): string {
  const trimmed = String(id ?? "").trim();
  if (trimmed && getCountryCodeById(trimmed)) return trimmed;
  return getCountryCodeById(fallback) ? fallback : COUNTRY_CODES[0]?.id ?? "us";
}
